import { CommonPurchaseCost } from '../purchase-cost'

export const CanadaPurchaseCost = CommonPurchaseCost
